import {
  apiGetOrganisationFiles,
  apiCopyAssessmentFile
} from '../../common/api/assessment'

const fetchOrganisationFiles = (benchmarkFilter = false) => ({
  requestPrefix: 'ORGANISATION_FILES:FETCH',
  request: () =>
    apiGetOrganisationFiles(benchmarkFilter, {
      include:
        'assessment_file.details,assessment_file.timestamps,assessment_file.student_type.account,assessment_file.student_type.account.names,assessment_file.contributions,assessment_file.contributors,assessment_file.contributor,assessment_file.account.names,assessment_file.account.avatar,assessment_file.works,assessment_file.work.medium.thumb'
    })
})

const filterToBenchmarked = () => ({
  type: 'ORGANISATION_FILES:FILTER_BENCHMARK'
})

const filterToAll = () => ({
  type: 'ORGANISATION_FILES:FILTER_ALL'
})

const copyOrganisationFile = id => ({
  requestPrefix: 'ORGANISATION_FILES:COPY',
  request: () => apiCopyAssessmentFile(id)
})

export {
  fetchOrganisationFiles,
  copyOrganisationFile,
  filterToBenchmarked,
  filterToAll
}
